var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6654 11.6667C31.6654 9.83337 30.1654 8.33337 28.332 8.33337H23.332V11.6667H28.332V16.0834L22.532 23.3334H16.6654V15H9.9987C6.31536 15 3.33203 17.9834 3.33203 21.6667V26.6667H6.66536C6.66536 29.4334 8.8987 31.6667 11.6654 31.6667C14.432 31.6667 16.6654 29.4334 16.6654 26.6667H24.132L31.6654 17.25V11.6667ZM6.66536 23.3334V21.6667C6.66536 19.8334 8.16536 18.3334 9.9987 18.3334H13.332V23.3334H6.66536ZM11.6654 28.3334C10.7487 28.3334 9.9987 27.5834 9.9987 26.6667H13.332C13.332 27.5834 12.582 28.3334 11.6654 28.3334Z",
    fill: "#8F161A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 10H16.6654V13.3333H8.33203V10ZM31.6654 21.6667C28.8987 21.6667 26.6654 23.9 26.6654 26.6667C26.6654 29.4333 28.8987 31.6667 31.6654 31.6667C34.432 31.6667 36.6654 29.4333 36.6654 26.6667C36.6654 23.9 34.432 21.6667 31.6654 21.6667ZM31.6654 28.3333C30.7487 28.3333 29.9987 27.5833 29.9987 26.6667C29.9987 25.75 30.7487 25 31.6654 25C32.582 25 33.332 25.75 33.332 26.6667C33.332 27.5833 32.582 28.3333 31.6654 28.3333Z",
    fill: "#8F161A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.8c1f507709b3a8c2450d23f1b527968a.svg";
export { ForwardRef as ReactComponent };